<template>
    <div class="block viewed-products">
        <div id="recommend-container">
        </div>
        <div id="bought-together">
        </div>
    </div>
</template>

<script>
import instantsearch from "instantsearch.js";
import algoliasearch from "algoliasearch/lite";
import { algoliaAppId, algoliaKeySearch, index } from "../../js/algoliaSettings";
import { relatedProducts, frequentlyBoughtTogether } from "instantsearch.js/es/widgets";
import { generateRecommendationHTML } from '../../js/algolia-plugins/recommendations-snippets'


export default {
    name: 'AlgoliaRecommendations',
    mounted() {
        const searchClient = algoliasearch(algoliaAppId(), algoliaKeySearch());
        const recommendText              = this.$t('algoliaRecommend.recommendedProducts');
        const recommendTextSubtitle      = this.$t('algoliaRecommend.recommendedProductsSubtitle');
        const boughtTogetherText         = this.$t('algoliaRecommend.boughtTogether');
        const boughtTogetherTextSubtitle = this.$t('algoliaRecommend.boughtTogetherSubtitle');

        const search = instantsearch({
            searchClient,
            indexName: index(),
        }).addWidgets([
            relatedProducts({
                container: '#recommend-container',
                objectIDs: [window.id_product.toString()],
                limit: 5,
                cssClasses: {
                    item: ['col-6', 'col-sm-4', 'col-lg-2', 'viewed-products__item', 'px-2', 'mb-4', ' mb-lg-0'],
                    list: ['row', 'list-unstyled', 'px-3', 'px-xl-5'],
                },
                templates: {
                    header({ cssClasses, items }, { html }) {
                        return `<br/><div class="viewed-products__header-section"><h2>${recommendText}</h2>
                        <span>${recommendTextSubtitle}</span></div>`;
                    },
                    item(recommendation, { html }) {
                        return generateRecommendationHTML(recommendation);
                    },
                }
            }),
            frequentlyBoughtTogether({
                container: '#bought-together',
                objectIDs: [window.id_product.toString()],
                limit: 5,
                cssClasses: {
                    item: ['col-6', 'col-sm-4', 'col-lg-2', 'viewed-products__item', 'px-2', 'mb-4', ' mb-lg-0'],
                    list: ['row', 'list-unstyled', 'px-3', 'px-xl-5'],
                },
                templates: {
                    header({ cssClasses, items }, { html }) {
                        return `<div class="viewed-products__header-section"><h2>${boughtTogetherText}</h2><span>${boughtTogetherTextSubtitle}</span></div>`;
                    },
                    item(recommendation, { html }) {
                        return generateRecommendationHTML(recommendation);
                    }
                }
            }),
        ]);

        try {
            search.start();
        } catch(error) {
            console.log('Got error with ', error);
        }
    }
};

</script>

